exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".logsApprovalModal .modal-dialog{width:750px}.logsApprovalModal .logTable{width:85%}.logsApprovalModal .instructionsText{text-align:center}.logsApprovalModal .outerTitles .buttonSuccess{min-width:40px!important;font-size:.8em}.logsApprovalModal .logTable{margin-bottom:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/parents/logs_approval_modal.scss
// module id = 1390
// module chunks = 0